import { render, staticRenderFns } from "./new-signer.vue?vue&type=template&id=3d8b1634&"
import script from "./new-signer.vue?vue&type=script&lang=ts&"
export * from "./new-signer.vue?vue&type=script&lang=ts&"
import style0 from "./new-signer.vue?vue&type=style&index=0&id=3d8b1634&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports